import {
  SimpleForm,
  type SimpleFormProps,
} from '../../components/admin/simple-form';
import { cn } from '../../lib/utils';
import { MoonstarEditFormToolbar } from './MoonstarEditFormToolbar';

/** Kit `SimpleForm` that validates on change, warns about unsaved changes and only has a save button. */
export const MoonstarEditForm = ({ className, ...props }: SimpleFormProps) => {
  return (
    <SimpleForm
      mode="onChange"
      warnWhenUnsavedChanges
      toolbar={<MoonstarEditFormToolbar />}
      {...props}
      className={cn(
        'rounded-xl border bg-card p-4 shadow-sm sm:p-6',
        className
      )}
    />
  );
};
